import { render } from "./SettlementDetails.vue?vue&type=template&id=2f7a2948"
import script from "./SettlementDetails.vue?vue&type=script&lang=js"
export * from "./SettlementDetails.vue?vue&type=script&lang=js"

import "./SettlementDetails.vue?vue&type=style&index=0&id=2f7a2948&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__